<template>
  <form-builder
    :chart="encounters.content"
    :treeFilter="treeFilter"
    :editMode="editMode"
    :selectedRecord="selectedRecord"
  ></form-builder>
</template>

<script>
import { mapGetters } from "vuex";
import FormBuilder from "./FormBuilder";

export default {
  name: "Encounters",
  components: {
    FormBuilder,
  },
  props: {
    editMode: Boolean,
    treeFilter: String,
    selectedRecord: Object,
  },
  data: () => ({}),
  computed: {
    ...mapGetters({
      encounters: "getEncounters",
    }),
  },
};
</script>
<style scoped>
</style>